import { Component, Input, OnInit } from '@angular/core';
import {
  ServiceDataSource,
  Restricao,
  RestricaoOperador,
  Restricoes,
  MensagemService,
  ProgressoService,
  RestricaoPadrao,
} from 'maestro-ng';
import { FonteDados } from '../../fonte-dados/fonte-dados.model';
import { FonteDadosComunicacao } from '../fonte-dados-comunicacao.model';
import { FonteDadosComunicacoService } from '../fonte-dados-comunicaco.service';
import { SelectItem } from 'primeng/api';
import { SelectItemService } from '../../services/select-item.service';

@Component({
  selector: 'app-fonte-dados-comunicacao-lista',
  templateUrl: './fonte-dados-comunicacao-lista.component.html',
  styleUrls: ['./fonte-dados-comunicacao-lista.component.css'],
})
export class FonteDadosComunicacaoListaComponent implements OnInit {
  public ds: ServiceDataSource<FonteDadosComunicacao, number>;

  @Input()
  public fonteDados: FonteDados;

  public getFonteDadosComunicacaoSituacao: SelectItem[];

  public carregando: boolean;
  public atributo: string;
  public valor: any;

  constructor(
    private service: FonteDadosComunicacoService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    private selectItemService: SelectItemService
  ) {
    this.ds = new ServiceDataSource<FonteDadosComunicacao, number>(
      (c) => this.service.recuperarTestesComunicacao(this.fonteDados, c),
      this.mensagemService,
      this.progressoService,
      15
    );
    this.ds.restricoes = new Restricoes([
      new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
      new Restricao<Date>({
        atributo: 'auditoriaDataInsercao',
        operador: RestricaoOperador.BETWEEN,
        padrao: RestricaoPadrao.DATE,
      }),
      new Restricao<string>({ atributo: 'situacao', operador: RestricaoOperador.EQUALS }),
      new Restricao<string>({ atributo: 'relatorio', operador: RestricaoOperador.CONTAINS }),
    ]);
  }

  ngOnInit(): void {
    this.progressoService.modal();
    this.getFonteDadosComunicacaoSituacao = this.selectItemService.getFonteDadosComunicacaoSituacao();
  }

  setarCor(situacao: string): string {
    return situacao === 'Sucesso' ? 'green' : 'red';
  }
}
